import FreshDeskWidget from "./FreshDeskWidget";

export default FreshDeskWidget;